/** Stessa logica di avanzamento usata nella griglia diagnosi e nello step Chiudi / esporta. */
export function computeDiagnosisChecklistProgress(
  requiredFields?: { checks?: Array<{ passed: boolean }> } | null,
  finalChecks?: { checks?: Array<{ passed: boolean }> } | null
): number {
  const checks = [...(requiredFields?.checks ?? []), ...(finalChecks?.checks ?? [])];
  if (!checks.length) return 0;
  const passed = checks.filter(c => c.passed).length;
  return Math.round((passed / checks.length) * 100);
}
